__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "roms-rotd-admin-host";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@aa-techops-ui/ping-authentication", "19.0.1", () => (__webpack_require__.e(934).then(() => (() => (__webpack_require__(/*! ./node_modules/@aa-techops-ui/ping-authentication/fesm2022/aa-techops-ui-ping-authentication.mjs */ 7553))))));
			register("@angular/common/http", "22.0.1", () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 6443))))));
			register("@angular/common", "22.0.1", () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 316))))));
			register("@angular/core/primitives/di", "22.0.1", () => (__webpack_require__.e(513).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives-di.mjs */ 8513))))));
			register("@angular/core/primitives/signals", "22.0.1", () => (__webpack_require__.e(699).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives-signals.mjs */ 6699))))));
			register("@angular/core", "22.0.1", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 7580))))));
			register("@angular/platform-browser", "22.0.1", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/platform-browser/fesm2022/platform-browser.mjs */ 436))))));
			register("@angular/router", "22.0.1", () => (__webpack_require__.e(72).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 5072))))));
			register("isomorphic-fetch", "3.0.0", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(/*! ./node_modules/isomorphic-fetch/fetch-npm-browserify.js */ 6620))))));
			register("oidc-client-ts", "3.0.1", () => (__webpack_require__.e(872).then(() => (() => (__webpack_require__(/*! ./node_modules/oidc-client-ts/dist/esm/oidc-client-ts.js */ 1491))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e(219).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/operators/index.js */ 8219))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/index.js */ 845))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};